<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lIN56C/tc-custom/9781597482110.jpg?1680803536976" alt="This image is the cover for the book Claiming the Crown, Hidden Falls High: A Loving Summer Spin-off"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Claiming the Crown, Hidden Falls High: A Loving Summer Spin-off
      </h1>
      <p class="bookDescription body article font2">
        <p>If you like 365 Days, and After, you'll love the steamy romances from Kailin Gow like this one.How do you stop a storm that has already been brewing, set in a path to wipe out all that stands in its way? Dante Black It's time to make my move. I've shown the princess some mercy. Instead of hitting hard on her, I diverted the attention of the Inner Circle to another. Now they have issued an order for me to move or they will send someone else who won't hesitate to finish the job. My own father, Cole Black. If you think I'm a monster, then you will think he's the devil. He once killed me off, only to resurrect me into his own likeness, but without a human heart which was replaced with a metal one. Summer was the one who brought my metal heart back to life, though. Too bad, she's also the Princess I was sent to destroy. ***Claiming the Crown is the third book in the USA Today Bestselling New Adult/YA Contemporary RH Dark Romance Series.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kailin Gow
      </h2>
      
      <p class="authorDescription body article">Kailin Gow is a million-selling author who has written and published close to 700 books under her name and various pen names in multiple genres since 2001. She is also an award-winning filmmaker whose films has screened all over the world including Cannes, Los Angeles, London, Paris, Japan, Korea, India, Germany, and Greece. Her books Bitter Frost and PULSE Vampires have been made into video games and is currently filming as featured films. She has been named as the most prolific Asian American author, and has been quoted as the representative for AAPI Heritage Week. Currently, two of her book series, Red Genesis, co-written by Kira G. and her science fiction romance series FADE have been optioned by the Netflix Top 2 Overall film production company Wish Dragon. She is set to write and direct the AAPI diverse cast featured film of Jane Austen’s Pride and Prejudice.  As an actress, she is currently in pre-production to star in 4 AAPI-led films, including her enemies-to-lover novel based on her relative’s ramen factory called Ramen Romance and her real-life experience as an author who has organized some of the biggest book signing events in her novel Love Letters from Las Vegas.  Go to KailinGow.com tfor updates and news.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sparklesoup.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6cb20103